import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '.';
import { handleGlobalSearch } from '@/utils';

export const mailTasksApi = createApi({
	reducerPath: 'mailTasksApi',
	tagTypes: ['summaryMails', 'reminderMails'],
	baseQuery: baseQuery,
	refetchOnMountOrArgChange: true,
	refetchOnReconnect: true,
	endpoints: (builder) => ({
		getEventTasks: builder.query({
			query: ({ id }: { id: string }) => ({
				url: `mailtasks/event/${id}`,
			}),
			providesTags: ['summaryMails', 'reminderMails'],
		}),
		getSummaryTaskMails: builder.query({
			query: ({ id, filters, page }: { id: string; page: number; filters: any }) => ({
				url: `mailtasks/${id}/mails`,
				params: { page, ...handleGlobalSearch(filters, ['receiver']) },
			}),
			providesTags: ['summaryMails'],
		}),
		getReminderTaskMails: builder.query({
			query: ({ id, filters, page }: { id: string; page: number; filters: any }) => ({
				url: `mailtasks/${id}/mails`,
				params: { page, ...handleGlobalSearch(filters, ['receiver']) },
			}),
			providesTags: ['reminderMails'],
		}),
		reSendFailedSummaryTaskMails: builder.mutation({
			query: ({ id }: { id: string }) => ({
				url: `mailtasks/${id}/resend`,
				method: 'POST',
			
			}),
			invalidatesTags: ['summaryMails'],
		}),
		reSendFailedReminderTaskMails: builder.mutation({
			query: ({ id }: { id: string }) => ({
				url: `mailtasks/${id}/resend`,
				method: 'POST',
			
			}),
			invalidatesTags: ['reminderMails'],
		}),
	}),
});

export const {
    useGetEventTasksQuery,
    useGetReminderTaskMailsQuery,
    useGetSummaryTaskMailsQuery,
	useReSendFailedReminderTaskMailsMutation,
	useReSendFailedSummaryTaskMailsMutation
} = mailTasksApi;
